import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const openPrivacy = () => setActiveModal('privacy');
  const openTerms = () => setActiveModal('terms');
  const closeModal = () => setActiveModal(null);
  return <footer className="py-12 bg-[#050b14] text-center border-t border-[#d4a843]/20 relative z-10" data-id="element-65">
      <div className="max-w-4xl mx-auto px-4" data-id="element-66">
        <h3 className="text-2xl font-serif text-[#d4a843] mb-4" data-id="element-67">
          Ingreso Invisible 2026
        </h3>
        <p className="text-gray-500 text-sm mb-6" data-id="element-68">
          Directo, pragmático, protector.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-4 mb-6 text-sm" data-id="element-69">
          <button onClick={openPrivacy} className="text-[#d4a843] hover:text-[#e8c66a] transition-colors hover:underline underline-offset-4" data-id="element-70">
            Política de Privacidad
          </button>
          <span className="text-[#d4a843]/40" data-id="element-71">•</span>
          <button onClick={openTerms} className="text-[#d4a843] hover:text-[#e8c66a] transition-colors hover:underline underline-offset-4" data-id="element-72">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-gray-600 text-xs" data-id="element-73">
          © 2026 Ingreso Invisible. Todos los derechos reservados.
        </p>
      </div>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-74">
        <div className="space-y-4 text-sm md:text-base leading-relaxed" data-id="element-75">
          <section data-id="element-76">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-77">
              1. Información que recopilamos
            </h3>
            <p data-id="element-78">
              Recopilamos información que usted nos proporciona directamente al
              adquirir nuestro producto digital, como su nombre, dirección de
              correo electrónico y detalles de pago. También podemos recopilar
              información automáticamente sobre su dispositivo y uso de nuestro
              sitio web mediante cookies y tecnologías similares.
            </p>
          </section>

          <section data-id="element-79">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-80">
              2. Uso de la información
            </h3>
            <p data-id="element-81">
              Utilizamos su información para procesar su compra, entregar el
              producto digital, enviarle actualizaciones importantes sobre el
              curso y mejorar nuestros servicios. No vendemos ni alquilamos su
              información personal a terceros.
            </p>
          </section>

          <section data-id="element-82">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-83">
              3. Protección de datos
            </h3>
            <p data-id="element-84">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger sus datos personales contra el acceso no autorizado, la
              pérdida o la alteración. Sus datos de pago son procesados por
              proveedores seguros y no almacenamos detalles completos de
              tarjetas de crédito.
            </p>
          </section>

          <section data-id="element-85">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-86">
              4. Cookies
            </h3>
            <p data-id="element-87">
              Utilizamos cookies para mejorar su experiencia de navegación y
              analizar el tráfico del sitio. Puede configurar su navegador para
              rechazar todas las cookies o para que le avise cuando se envíe una
              cookie.
            </p>
          </section>

          <section data-id="element-88">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-89">
              5. Derechos del usuario
            </h3>
            <p data-id="element-90">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal. Si desea ejercer estos derechos o tiene preguntas sobre
              nuestra política de privacidad, contáctenos a través de los
              canales oficiales.
            </p>
          </section>

          <section data-id="element-91">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-92">
              6. Cambios a esta política
            </h3>
            <p data-id="element-93">
              Nos reservamos el derecho de actualizar esta política de
              privacidad en cualquier momento. Le notificaremos sobre cambios
              significativos enviando un aviso a la dirección de correo
              electrónico que nos proporcionó o publicando un aviso destacado en
              nuestro sitio.
            </p>
          </section>
        </div>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-94">
        <div className="space-y-4 text-sm md:text-base leading-relaxed" data-id="element-95">
          <section data-id="element-96">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-97">
              1. Aceptación de términos
            </h3>
            <p data-id="element-98">
              Al acceder y adquirir "El Método Ingreso Invisible 2026", usted
              acepta estar legalmente vinculado por estos términos y
              condiciones. Si no está de acuerdo con alguno de estos términos,
              no debe utilizar ni adquirir este producto.
            </p>
          </section>

          <section data-id="element-99">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-100">
              2. Descripción del producto
            </h3>
            <p data-id="element-101">
              Este es un producto digital educativo que incluye guías,
              estrategias y recursos para la creación de contenido sin rostro.
              El acceso se otorga de manera inmediata tras la confirmación del
              pago. No se envían productos físicos.
            </p>
          </section>

          <section data-id="element-102">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-103">
              3. Propiedad intelectual
            </h3>
            <p data-id="element-104">
              Todo el contenido incluido en este producto (textos, gráficos,
              logotipos, videos, audios) es propiedad exclusiva de Ingreso
              Invisible y está protegido por leyes de derechos de autor. Queda
              estrictamente prohibida la reproducción, distribución o venta no
              autorizada de este material.
            </p>
          </section>

          <section data-id="element-105">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-106">
              4. Política de reembolso
            </h3>
            <p data-id="element-107">
              Ofrecemos una garantía de satisfacción de 30 días. Si no está
              satisfecho con el producto, puede solicitar un reembolso completo
              dentro de los 30 días posteriores a la compra, siempre que
              demuestre haber intentado aplicar el método.
            </p>
          </section>

          <section data-id="element-108">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-109">
              5. Limitación de responsabilidad
            </h3>
            <p data-id="element-110">
              Este producto es para fines educativos e informativos. No
              garantizamos resultados específicos ni ingresos exactos, ya que
              estos dependen del esfuerzo y la implementación individual de cada
              usuario. No somos asesores financieros y no nos hacemos
              responsables de decisiones financieras tomadas basadas en esta
              información.
            </p>
          </section>

          <section data-id="element-111">
            <h3 className="text-[#d4a843] font-bold text-lg mb-2" data-id="element-112">
              6. Ley aplicable
            </h3>
            <p data-id="element-113">
              Estos términos se regirán e interpretarán de acuerdo con las leyes
              vigentes en México, sin tener en cuenta sus conflictos de
              disposiciones legales.
            </p>
          </section>
        </div>
      </LegalModal>
    </footer>;
}